import nunjucks from 'nunjucks'
import { type CompiledEmail } from '../compile/compile'
import { type EmailVariable } from '../emailTemplateTypes'
import { validateCompiled } from '../validate/jinjaAllowlist'

const bodyEnvironment = new nunjucks.Environment(null, { autoescape: true, throwOnUndefined: true })
const subjectEnvironment = new nunjucks.Environment(null, { autoescape: false, throwOnUndefined: true })

export interface RenderedPreview {
  subject: string
  body: string
  error: string | null
}

export const samplesFor = (variables: EmailVariable[]): Record<string, string> =>
  Object.fromEntries(variables.map((variable) => [variable.name, variable.sample]))

export const sampleSenderName = (samples: Record<string, string>): string =>
  [samples.advisor_first_name, samples.advisor_last_name].filter(Boolean).join(' ') || 'Advisor name'

export const renderPreview = (email: CompiledEmail, samples: Record<string, string>, variableNames: string[]): RenderedPreview => {
  const disallowed = validateCompiled(email.subject, email.body, variableNames)
  if (disallowed.length) {
    return { subject: '', body: '', error: disallowed[0] }
  }
  try {
    return { subject: subjectEnvironment.renderString(email.subject, samples), body: bodyEnvironment.renderString(email.body, samples), error: null }
  } catch (error) {
    return { subject: '', body: '', error: error instanceof Error ? error.message : String(error) }
  }
}
